import { InputField } from "kubra-ux-forge";
import React from "react";
import { useField } from "formik";

interface AmountFieldProps {
  name: string;
  label: string;
  placeholder?: string;
  editableIfPrefilled?: boolean;
}

export const AmountField: React.FC<AmountFieldProps> = ({
  name,
  label,
  placeholder,
  editableIfPrefilled,
}) => {
  const [field, meta] = useField(name);

  let disabled = false;

  if (meta.initialValue && !editableIfPrefilled) {
    disabled = true;
  }

  return (
    <div>
      <InputField
        {...field}
        label={label}
        name={name}
        errorText={meta.touched ? meta.error : undefined}
        hasError={meta.touched ? !!meta.error : false}
        aria-invalid={meta.touched && !!meta.error}
        dataCy={name}
        placeholder={placeholder}
        disabled={disabled}
        // TODO: make the currency symbol dynamic.
        prefix={"$"}
      />
    </div>
  );
};
